/** Títulos estáticos dos passos de onboarding — mesma fonte usada no checklist e no tour. */
export const ONBOARDING_STEP_TITLES: Record<string, string> = {
  BRANDING: 'Personalização visual',
  BUSINESS_HOURS: 'Horário de funcionamento',
  SERVICES: 'Serviços cadastrados',
  ACCESS_CONTROL: 'Grupos de acesso',
  TEAM: 'Equipe / profissionais',
  SERVICE_ASSIGNMENT: 'Serviços atribuídos',
  SUBSCRIPTION: 'Assinatura ou trial',
  FIRST_COMPLETED_APPOINTMENT: 'Primeiro agendamento',
  WHATSAPP_CHANNEL: 'Canal WhatsApp',
};

export function getOnboardingStepTitle(stepId: string): string {
  return ONBOARDING_STEP_TITLES[stepId] ?? stepId;
}
